import { render, staticRenderFns } from "./updateManageNotification.vue?vue&type=template&id=ebc06bf2"
import script from "./updateManageNotification.vue?vue&type=script&lang=js"
export * from "./updateManageNotification.vue?vue&type=script&lang=js"
import style0 from "./updateManageNotification.vue?vue&type=style&index=0&id=ebc06bf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports